export const getCurrencyExchangeList = state => {
    return state.list
}

export const getCurrencyExchangeDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/currencyExchange/getters.js